// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".left[data-v-1a21ccc2]{text-align:left;margin-right:auto}.right[data-v-1a21ccc2]{text-align:right;margin-left:auto}.center[data-v-1a21ccc2]{text-align:center;margin:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
